/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useHookstate } from '@hookstate/core'; 
import StandardModal from '../../../../components/StandardModal';
import ReportingRecord from '../CreateVideoMonitoringForm';
import { useLang } from '../../../../hooks/useLang';
import { useLocation } from 'react-router';
import useSystemState from '~/features/System/stores/SystemState';
import { storeScreenSettings } from '~/features/System/services';
import { authFetch } from '~/services/fetch'; 
import ScreenSettingsDraggableProps from '~/features/Entry/interfaces/IPositionDraggable';
import { Grid, Typography } from '@mui/material';
import useUserState from '~/features/User/stores/UserState';
import useStationState from '~/features/Station/stores/StationState';
import useSurveillanceReportingState from '../../stores/SurveillanceReportingState';

const modal = document.getElementById('div-modal') as HTMLElement;

export default function CreateVideoMonitoringModalDraggable() {
  const { translate } = useLang();
  const { windowManager, loadingButton } = useSystemState();
  const location = useLocation();
  const { user } = useUserState();
  const { station } = useStationState();
  const { surveillanceReportingStates } = useSurveillanceReportingState();
  const loadingComponent = useHookstate(true);

  const getPositionsDraggable = useHookstate<ScreenSettingsDraggableProps>({
    id: 0,
    user_id: 0,
    url: '',
    window_name: '',
    x_position: 80,
    y_position: 141,
    is_window_open: true,
    is_window_minimized: false,
    created_at: new Date().toJSON(),
    updated_at: new Date().toJSON(),
    deleted_at: null
  });

  useEffect(() => {
    authFetch({
      url: '/screen-setting/get-user-settings',
      method: 'POST',
      data: {
        url: location.pathname,
      }
    }).then((response) => {
      if ('CreateVideoMonitoringModalDraggable' in response.data) {
        getPositionsDraggable.set(response.data.CreateVideoMonitoringModalDraggable);
      }
    }).finally(() => {
      loadingComponent.set(false);
    });

    return () => {
      windowManager()['createVideoMonitoring'].open.set(false);
    };
  }, []);

  const handleStop = (event, dragElement) => {
    event.stopPropagation();
    event.preventDefault();

    getPositionsDraggable.x_position.set(dragElement.x);
    getPositionsDraggable.y_position.set(dragElement.y);
  };

  useEffect(() => {
    return () => {
      storeScreenSettings({
        windowName: 'CreateVideoMonitoringModalDraggable',
        isOpen: windowManager()['createVideoMonitoring'].open.get(),
        isMinimized: getPositionsDraggable.is_window_minimized?.get(),
        positionX: getPositionsDraggable?.x_position?.get(),
        positionY: getPositionsDraggable?.y_position?.get(),
      });
    };
  }, [
    windowManager()['createVideoMonitoring'].open.get(),
    getPositionsDraggable.is_window_minimized?.get(),
    getPositionsDraggable?.x_position?.get(),
    getPositionsDraggable?.y_position?.get(),
  ]);

  const userName = user().name?.value || 'Usuário';
  const stationName = station().get()?.name || 'Estação';
  
  const { save, showCheckbox, isAssociateMode, isEditMode } = surveillanceReportingStates();
  
  let modalTitle = translate('CreateVideomonitoring');
  if (save.value && isEditMode.value) {
    modalTitle = translate('Edit Report');
  } else if (showCheckbox.value || isAssociateMode.value) {
    modalTitle = translate('Associate Reports to Occurrence');
  }

  const shouldRender = 
    windowManager()['createVideoMonitoring'].open.value && 
    location.pathname === '/video-monitoring' && 
    !loadingButton.value && 
    !loadingComponent.value;

  return ReactDOM.createPortal(
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {shouldRender && (
        <StandardModal
          title={
            <Grid
              container
              sx={{
                flexDirection: 'row',
                alignItems: 'start',
                textAlign: 'start',
              }}
            >
              <Grid item sx={{ alignSelf: 'start', marginRight: 'auto' }}>
                <Typography>
                  {modalTitle}
                </Typography>
                <Typography variant="subtitle2" color={'text.secondary'}>
                  {`Relato por ${userName} na estação ${stationName}`}
                </Typography>
              </Grid>
            </Grid>
          }
          dimensions={{ width: 800 }}
          handleStop={handleStop}
          isExpanded={getPositionsDraggable.is_window_minimized}
            position={{
              x: getPositionsDraggable?.x_position?.get() ? Number(getPositionsDraggable?.x_position?.get()) : 250, // eslint-disable-line id-length
              y: getPositionsDraggable?.y_position?.get() ? Number(getPositionsDraggable?.y_position?.get()) : 100 // eslint-disable-line id-length
            }}
          closeButton={false}
          variant={'h5'}
        >
          <ReportingRecord />
        </StandardModal>
      )}
    </>,
    modal
  );
}
